<template>
  <div class="charactor-wrapper">
    <div :style="style">
    <transition
    name="fade"
    @before-leave="move"
    @after-leave="reset"
    >
    <span class="char-span"  v-if="isShow" >{{charFormatted}}</span>
    </transition>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      counter:0,
      style:{
        display:'inline-block',
        position:"absolute",
        top:'0px',
        right:'0px',
        transform:'rotate(0deg)'
      }
    }
  },
  props:{
    char:{
      type:String,
      required:true
      },
    isShow:{
      type:Boolean,
      default:()=>{
        return true
      }
      },
  },
  computed:{
    charFormatted(){
      return this.char
    }
  },
  methods:{
    reset(){
        this.style.top = `0px`
        this.style.right = `0px`
        this.style.transform= 'rotate(0deg)'
        },
    move() {
      // 初期化
      this.reset()
      this.counter=0
      // xy方向と回転速度を決定
      const increaseNumY = this.getRandom(4)- 2
      const increaseNumX = this.getRandom(4)-2
      const rotaleDeg = this.getRandom(4)-2 
      // interval
      const intervalID = setInterval(()=>{
        // 位置と角度を新しく設定
        this.style.top = `${this.counter*increaseNumY}px`
        this.style.right = `${this.counter*increaseNumX}px`
        this.style.transform = `rotate(${this.counter*rotaleDeg}deg)`
        // 透明になるまでの時間よりも長ければいい
        if(this.counter>20){
          clearInterval(intervalID)
          this.counter=0
        }
        // カウンタを増やす
        this.counter ++
      },100)
    },
    getRandom(max){
      return Math.floor(Math.random() * Math.floor(max));
    }
  }
}
</script>

<style>
.charactor-wrapper{
  display: inline-block;
  position: relative;
  min-height:30px;
  min-width: 30px;
}

.char-span{
  display: inline-block !important;
}

.fade-enter-to{
  transform : rotate(0deg) ;
}

.fade-leave-active {
  transition: opacity 1.5s cubic-bezier(0.12, 0, 0.39, 0) 0.5s, transform 2.5s cubic-bezier(0.34, 1.56, 0.64, 1)  ,font-size 1s;
}
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  font-size:35px;
  transform: skewX(45deg);
}
</style>